import { Box, Typography, Button } from '@mui/material';
import FadeIn from './FadeIn';
import Link from 'next/link';

interface TipCardProps {
  title: string;
  summary: string;
  slug: string;
}

export default function TipCard({ title, summary, slug }: TipCardProps) {
  return (
    <FadeIn>
      <Box
        sx={{
          p: 4,
          bgcolor: 'rgba(36,61,99,0.8)',
          color: '#fff',
          borderRadius: 2,
          border: '1px solid rgba(255,255,255,0.2)',
        }}
      >
        <Typography variant="h6" component="p" fontWeight="bold">{title}</Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>{summary}</Typography>
        <Button
          variant="text"
          component={Link}
          href={`/blog/${slug}`}
          sx={{ mt: 2 }}
        >
          Read More
        </Button>
      </Box>
    </FadeIn>
  );
}
